import { userProfileStrings } from "constants/constantStrings";
import { SETTINGS_PAGES } from "constants/pages.constant";

import Adduser from "assets/UserProfile/add_User.svg";
import Manual from "assets/UserProfile/document_Description.svg";
import Launch from "assets/UserProfile/launch.svg";
import NotificationSettingsIcon from "assets/UserProfile/notification_Settings.svg";
import Systems from "assets/UserProfile/system_and_Device.svg";
import AccountSetting from "assets/UserProfile/user_Settings.svg";

export const getSettingsOptions = (isAdmin, hasSystemAccess) => [
  { id: SETTINGS_PAGES.ACCOUNT, icon: AccountSetting, name: userProfileStrings.accountSetting, isVisible: true },
  { id: SETTINGS_PAGES.NOTIFICATION, icon: NotificationSettingsIcon, name: userProfileStrings.notificationSetting, isVisible: true },
  { id: SETTINGS_PAGES.USERS, icon: Adduser, name: userProfileStrings.manageUsers, isVisible: isAdmin && hasSystemAccess },
  { id: SETTINGS_PAGES.SYSTEMS, icon: Systems, name: userProfileStrings.systems, isVisible: isAdmin && hasSystemAccess },
  { id: SETTINGS_PAGES.USERGUIDE, icon: Manual, name: userProfileStrings.userGuide, isVisible: true, secondaryIcon: Launch }
];
